<template>
  <v-main>

    <v-container
        id="update-password-container"
        fluid
        tag="section"
    >

      <base-material-card
          icon="mdi-lock-reset"
          class="px-5 py-3"
          ref="form"
      >

        <v-card-text>

          <div data-cy="change-password-message">
            <shared-page-messages :error-messages="errorMessages"
                                  :warning-messages="warningMessages"
                                  :success-messages="successMessages">
            </shared-page-messages>
          </div>


          <v-form ref="updatePasswordForm"
                  v-model="valid"
                  lazy-validation
                  v-if="!success"
                  @submit.prevent="submit"
                  @submit="validate"
          >

            <p>Please complete the fields below to change your password.</p>

            <v-row>

              <v-col
                  cols="12"
                  sm="4"
              >
                <v-text-field
                    v-model="currentPassword"
                    label="Current Password"
                    type="password"
                    validate-on-blur
                    :rules="rules.required"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>

              <v-col
                  cols="12"
                  sm="4"
              >
                <v-text-field
                    v-model="newPassword"
                    label="New Password"
                    type="password"
                    validate-on-blur
                    :rules="rules.newPassword"
                ></v-text-field>
              </v-col>
              <v-col
                  cols="12"
                  sm="4"
              >
                <v-text-field
                    v-model="confirmNewPassword"
                    label="Re-Enter New Password"
                    type="password"
                    :rules="rules.confirmNewPassword"
                ></v-text-field>
              </v-col>
            </v-row>


            <v-row>
              <v-col
                  cols="12"
                  sm="4"
              >
                <div class="my-2">
                  <v-btn
                      color="primary"
                      dark
                      type="submit"
                  >
                    Submit
                  </v-btn>
                </div>
              </v-col>
            </v-row>

          </v-form>


        </v-card-text>

      </base-material-card>

    </v-container>

  </v-main>
</template>

<script>
import api from '@/services/api'
import validation from '@/utils/validation'
import constants from '@/utils/constants'
import {mapGetters} from "vuex";
import SharedPageMessages from '@/views/components/shared/PageMessages.vue'

export default {
  name: 'CoreUpdatePasswordView',
  components: {SharedPageMessages},

  created() {
    this.userId = this.getUserId
  },

  computed: {
    ...mapGetters({
      getUserId: 'getUserId'
    })
  },

  methods: {
    validate () {
      this.errorMessages = []
      this.successMessages = []
      this.warningMessages = []
      if(this.$refs.updatePasswordForm.validate()) {
        this.updatePassword()
      }
    },
    updatePassword() {
      this.$gtag.event('change_password')
      this.success = false
      let payload = {
        currentPassword: this.currentPassword,
        newPassword: this.newPassword
      }
      api
          .updatePassword(this.userId, payload)
          .then(response => {
            if (response.status === 200) {
                this.success = true
                this.successMessages.push('Your password has been updated successfully.')
            }
          })
          .catch(err => {
            this.handleError(err)
          })
    },
    handleError(err) {
      let errorMessage = api.parseResponseError(err, true)
      this.errorMessages.push(errorMessage)
    }
  },

  data() {
    return {
      valid: false,
      errorMessages: [],
      successMessages: [],
      warningMessages: [],
      success: null,
      userId: null,
      currentPassword: null,
      newPassword: null,
      confirmNewPassword: null,
      rules: {
        required: [
          v => validation.isRequired(v) || 'required'
        ],
        newPassword: [
          v => (v && v.length >= constants.PASSWORD_MIN_LENGTH) || `must have a minimum length of ${constants.PASSWORD_MIN_LENGTH}`
        ],
        confirmNewPassword: [
          v => (this.newPassword === this.confirmNewPassword) || 'new password confirmation must match new password'
        ]
      }
    }
  }
}
</script>
